/* global Homie */

import LoaderPopup from '../../shared/libs/LoaderPopup';
import axios from 'axios';
export default {
  template: '#auth-term',
  props: [],
  data() {
    return {
      guaranty: false,
      commission: false,
      resource: {
        home: {
          owner_id: Homie.user.owner ? Homie.user.owner._id['$oid'] : false,
          advisor_id: Homie.user.advisor ? Homie.user.advisor._id['$oid'] : false
        }
      }
    }
  },
  mounted() {
    setTimeout(() => {
      $("html, body").animate({ scrollTop: 0 }, 200);
    }, 1000);
  },
  methods: {
    openClose(property) {
      this[property] = !this[property];
    },
    startOnboarding() {
      let scope = this;

      LoaderPopup.show();

      axios.put('/users/publishing-agreement/accepting.json').then(createHome, scope.onErrorResponse);

      function createHome(){
        let createHomeUrl = scope.getCreateHomeUrl();
        axios.post(createHomeUrl, scope.$data.resource).then(onSuccess, scope.onErrorResponse);

        function onSuccess(response){
          LoaderPopup.hide();
          window.location.href = `/homes/${response.data.id}/edit/`;
        }
      }
    },
    getCreateHomeUrl: function(){
      if(!Homie.onboardingRole) return;
      switch(Homie.onboardingRole){
        case 'owner':
          return '/homes';
        case 'advisor':
          return '/homes/create-advisors';
        default:
          throw 'Invalid role.';
      }
    }
  }
}